import { DetailCard } from "@risalabs_frontend_org/oasis-ui-kit";
import { FaxLetterIdentification } from "../../../api/postCall/faxLetter";
import { formatDate } from "../../../utils/formatDate";
import "../../authorisationDetails/authorisationDetails.scss";
import { PLACEHOLDER } from "../../authorisationDetails/utils/constants";
import { IDENTIFICATION_TITLE, SECTION_HEADER_CLASS } from "../utils/constants";
import LabelledValue from "./LabelledValue";

interface IdentificationCardProps {
  identification: FaxLetterIdentification;
}

/** Who and what the letter is about: patient, member id, payer, J-code, and date of service. */
const IdentificationCard = ({ identification }: IdentificationCardProps) => (
  <DetailCard
    title={IDENTIFICATION_TITLE}
    headerClassName={SECTION_HEADER_CLASS}
  >
    <div className="authorisation-details__row">
      <LabelledValue label="Patient Name" value={identification.patient_name} />
      <LabelledValue label="Member ID" value={identification.member_id} />
      <LabelledValue label="Payer" value={identification.payer} />
      <LabelledValue label="J Code" value={identification.j_code} />
      <LabelledValue
        label="DOS"
        value={formatDate(
          identification.date_of_service,
          "MM-DD-YYYY",
          PLACEHOLDER,
        )}
      />
    </div>
  </DetailCard>
);

export default IdentificationCard;
